export function baseURL() {
  return window.env.BASE_URL;
}
